<ng-container *ngIf="tableBase?.dataSource?.latestData | async as data">
    <div
        *ngIf="!!data?.data?.length"
        class="filter-actions"
        fxLayout="row"
        fxLayoutAlign="start center"
        [ngClass]="{
            'hidden-filters-and-paginator': (data?.data?.length ?? 0) > 0 && (data?.data?.length ?? 0) < 10
        }"
    >
        <button
            (click)="$event.stopPropagation()"
            [matMenuTriggerFor]="menuSendAllEmail"
            mat-icon-button
            matTooltip="Send email"
            i18n-matTooltip
        >
            <mat-icon>email</mat-icon>
        </button>
        <mat-menu #menuSendAllEmail="matMenu">
            <button mat-menu-item (click)="$event.stopPropagation(); onEmailSelected()">
                <mat-icon>email</mat-icon>
                <span i18n>Send email</span>
            </button>
            <button mat-menu-item (click)="$event.stopPropagation(); onMessageSelected()">
                <mat-icon>speaker_notes</mat-icon>
                <span i18n>Send message to all</span>
            </button>
        </mat-menu>
    </div>
</ng-container>
<app-user-table-base
    #tableBase
    matSortActive="requested_at"
    [columnsData]="columnsData"
    [columnsKeys]="columnsKeys"
    [expandedRowId]="expandedRowId"
    [expandedFn]="expandedFn"
    (expansionToggled)="expansionToggled($event)"
    [otherContext]="otherContext"
    [expandingTable]="false"
    [canSelect]="false"
    [filtersExpanded]="true"
    [filter]="filter"
    [tableFilterItems]="tableFilterItems"
    [usersCountToHideFiltersAndPaginator]="10"
>
    <ng-container tableFiltersTempl>
        <app-table-filter
            [filtersTogglesInOnBtn]="true"
            [defaultFilter]="GlobalFilterProperty.SEARCH"
            [inGlobalFilter]="true"
            color="accent"
            #filter
        >
            <app-table-search
                toggleBtnLabel="Schema"
                i18n-toggleBtnLabel
                [inGlobalFilter]="true"
                class="align-space"
                searchFilterRef
            ></app-table-search>
            <app-select-filter
                [inGlobalFilter]="true"
                class="filter-space"
                label="Approval"
                i18n-label
                [property]="GlobalFilterProperty.REVIEW_STATUS"
                [options]="approvalStatusOptions"
                resApprovalStatusRef
            ></app-select-filter>
        </app-table-filter>
    </ng-container>
</app-user-table-base>

<ng-template #img let-user>
    <app-image-view
        [ngStyle]="{ minWidth: '50px' }"
        [isCircularImg]="true"
        [ignoreThumbnail]="true"
        [media_id]="user.media"
        paddingBottom="50px"
    ></app-image-view>
</ng-template>
<ng-template #name let-user>
    <ng-container *ngIf="!(isMobile$ | async)">
        <span
            [ngStyle]="{
                color:
                    user.enrollment?.approval_status === 'approved'
                        ? '#bfd8d0'
                        : user.enrollment?.approval_status === 'rejected'
                        ? '#a7a7a7'
                        : '#ff9961'
            }"
        >
            {{ user.name }}</span
        >
    </ng-container>
    <ng-container *ngIf="isMobile$ | async">
        <div fxLayout="row" fxLayoutGap="5px" class="w-100" fxLayoutAlign="start start">
            <app-image-view
                [ngStyle]="{ minWidth: '50px' }"
                [isCircularImg]="true"
                [ignoreThumbnail]="true"
                [media_id]="user.media"
                paddingBottom="50px"
            ></app-image-view>
            <span class="res-title" fxFlex="grow"> {{ user.name }}</span>
            <div fxLayout="column" fxLayoutAlign="start start">
                <button
                    *ngIf="user.id as expandId"
                    class="mob-expand-btn"
                    (click)="$event.stopPropagation(); expansionToggled(user)"
                    mat-icon-button
                >
                    <mat-icon>{{ expandedFn(user) ? 'expand_less' : 'expand_more' }}</mat-icon>
                </button>
            </div>
        </div>
    </ng-container>
</ng-template>

<ng-template #registred_date let-user>
    <span *ngIf="isMobile$ | async" class="mobile-label" i18n="@@registerationDate">Registeration date</span>
    <div [matTooltip]="user.enrollment?.requested_at | kdDateFormat : 'YYYY-MM-DD HH:mm'" class="bold-text">
        {{ user.enrollment?.requested_at | kdDateFormat : 'MMM D, HH:mm' }}
    </div>
</ng-template>
<ng-template #competence_status let-user>
    <span *ngIf="isMobile$ | async" class="mobile-label" i18n="@@competence">Competence</span>
    <span
        *ngIf="getCircleMetadata(user.competence) as metadata"
        [matTooltip]="metadata.tooltip"
        class="comp-header-Item {{ metadata.class }}"
        >{{ metadata.value }}</span
    >
</ng-template>
<ng-template #registration_status let-user>
    <span *ngIf="isMobile$ | async" class="mobile-label" i18n="@@decision">Decision</span>
    <div
        [matTooltip]="user.enrollment?.updated_at | kdDateFormat : 'YYYY-MM-DD HH:mm'"
        fxLayout="row"
        fxLayoutAlign="start center"
        fxLayoutGap="5px"
        *ngIf="user.enrollment?.approval_status === 'enrolled'"
        (click)="$event.stopPropagation()"
    >
        <div fxLayout="row" class="status-text approved-status" fxLayoutAlign="start center" fxLayoutGap="5px">
            <mat-icon>check_circle</mat-icon>
            <span i18n="@@enrolled">Enrolled</span>
        </div>
    </div>
    <div
        [matTooltip]="user.enrollment?.updated_at | kdDateFormat : 'YYYY-MM-DD HH:mm'"
        fxLayout="row"
        fxLayoutAlign="start center"
        fxLayoutGap="5px"
        *ngIf="user.enrollment?.approval_status === 'approved'"
        (click)="$event.stopPropagation()"
    >
        <div
            fxLayout="row"
            (click)="$event.stopPropagation(); onChngeStatus(user, 'approved')"
            class="status-text approved-status"
            fxLayoutAlign="start center"
            fxLayoutGap="5px"
        >
            <mat-icon>task_alt</mat-icon>
            <span i18n="@@approved">Approved</span>
        </div>
        <mat-icon class="approved-status" [matMenuTriggerFor]="pendingMenu">expand_more</mat-icon>
    </div>
    <div
        [matTooltip]="user.enrollment?.updated_at | kdDateFormat : 'YYYY-MM-DD HH:mm'"
        fxLayout="row"
        fxLayoutAlign="start center"
        fxLayoutGap="5px"
        (click)="$event.stopPropagation()"
        *ngIf="user.enrollment?.approval_status === 'rejected'"
    >
        <div
            fxLayout="row"
            class="status-text rejected-status"
            fxLayoutAlign="start center"
            fxLayoutGap="5px"
            (click)="$event.stopPropagation(); onChngeStatus(user, 'rejected')"
        >
            <mat-icon>cancel</mat-icon>
            <span i18n="@@rejected">Rejected</span>
        </div>
        <mat-icon class="rejected-status" [matMenuTriggerFor]="pendingMenu">expand_more</mat-icon>
    </div>
    <div
        [matTooltip]="user.enrollment?.updated_at | kdDateFormat : 'YYYY-MM-DD HH:mm'"
        fxLayout="row"
        class="status-text pending-status"
        fxLayoutAlign="start center"
        fxLayoutGap="5px"
        (click)="$event.stopPropagation()"
        *ngIf="user.enrollment?.approval_status == 'waiting'"
    >
        <div
            fxLayout="row"
            class="status-text pending-status"
            fxLayoutAlign="start center"
            fxLayoutGap="5px"
            (click)="$event.stopPropagation(); onChngeStatus(user, 'waiting')"
        >
            <mat-icon>pending</mat-icon>
            <span i18n="@@waitinglist">Waiting list</span>
        </div>
        <mat-icon class="pending-status" [matMenuTriggerFor]="pendingMenu">expand_more</mat-icon>
    </div>
    <div
        [matTooltip]="user.enrollment?.updated_at | kdDateFormat : 'YYYY-MM-DD HH:mm'"
        fxLayout="row"
        class="status-text pending-status"
        fxLayoutAlign="start center"
        fxLayoutGap="5px"
        (click)="$event.stopPropagation()"
        *ngIf="user.enrollment?.approval_status == 'deleted'"
    >
        <div
            fxLayout="row"
            class="status-text pending-status"
            fxLayoutAlign="start center"
            fxLayoutGap="5px"
            (click)="$event.stopPropagation()"
        >
            <mat-icon>cancel</mat-icon>
            <span i18n="@@deleted">Deleted</span>
        </div>
    </div>
    <div
        [matTooltip]="user.enrollment?.updated_at | kdDateFormat : 'YYYY-MM-DD HH:mm'"
        fxLayout="row"
        class="status-text pending-status"
        fxLayoutAlign="start center"
        fxLayoutGap="5px"
        (click)="$event.stopPropagation()"
        *ngIf="user.enrollment?.approval_status == 'pending'"
    >
        <div
            fxLayout="row"
            class="status-text pending-status"
            fxLayoutAlign="start center"
            fxLayoutGap="5px"
            (click)="$event.stopPropagation(); onChngeStatus(user, 'pending')"
        >
            <mat-icon>pending_actions</mat-icon>
            <span i18n="@@pending">Pending</span>
            <mat-icon class="orangeColor" *ngIf="!!user.approval_waiting">pending</mat-icon>
        </div>
        <mat-icon class="pending-status" [matMenuTriggerFor]="pendingMenu">expand_more</mat-icon>
    </div>
    <mat-menu #pendingMenu="matMenu">
        <button
            [disabled]="user.enrollment?.approval_status === 'approved' || (!occasion && !resource?.hasAvailableSeats)"
            mat-menu-item
            class="approved-status"
            (click)="$event.stopPropagation(); onChngeStatus(user, 'approved', false)"
        >
            <mat-icon>check_circle</mat-icon>
            <span i18n="@@approve">Approve</span>
        </button>
        <button
            [disabled]="user.enrollment?.approval_status === 'rejected'"
            mat-menu-item
            class="rejected-status"
            (click)="$event.stopPropagation(); onChngeStatus(user, 'rejected', false)"
        >
            <mat-icon>cancel</mat-icon>
            <span i18n="@@reject">Reject</span>
        </button>
        <button
            [disabled]="user.enrollment?.approval_status === 'waiting'"
            mat-menu-item
            class="pending-status"
            (click)="$event.stopPropagation(); onChngeStatus(user, 'waiting', false)"
        >
            <mat-icon>pending</mat-icon>
            <span i18n="@@waitinglist">Waiting list</span>
        </button>
    </mat-menu>
</ng-template>

<ng-template #tools let-user>
    <div class="tools-cell-wrapper">
        <button
            (click)="$event.stopPropagation(); onSelectStats(user)"
            matTooltip="Statistics"
            mat-icon-button
            class="action"
            i18n-matTooltip="@@staticstics"
        >
            <mat-icon>insights</mat-icon>
        </button>
        <button
            [matMenuTriggerFor]="menuSendEmail"
            (click)="$event.stopPropagation()"
            mat-icon-button
            [matTooltip]="authUser?.getActivationMailInfo(user)?.tooltip ?? ''"
            [ngClass]="authUser?.getActivationMailInfo(user)?.class"
        >
            <mat-icon>email</mat-icon>
        </button>
        <mat-menu #menuSendEmail="matMenu">
            <button
                [matTooltip]="authUser?.getActivationMailInfo(user)?.tooltip ?? ''"
                [ngClass]="authUser?.getActivationMailInfo(user)?.class"
                mat-menu-item
                (click)="$event.stopPropagation(); sendEmail(user)"
            >
                <mat-icon>email</mat-icon>
                <span i18n>Send email</span>
            </button>
            <button mat-menu-item (click)="$event.stopPropagation(); sendMsg(user)">
                <mat-icon>speaker_notes</mat-icon>
                <span i18n>Send message</span>
            </button>
        </mat-menu>
        <!-- <button
            matTooltip="Send message"
            i18n-matTooltip
            mat-icon-button
            (click)="$event.stopPropagation(); sendMsg(user)"
        >
            <mat-icon>speaker_notes</mat-icon>
        </button> -->
        <button
            *ngIf="occasion && resourceOccasionDates && resourceOccasionDates?.length > 1"
            matTooltip="Change occasion"
            i18n-matTooltip
            mat-icon-button
            class="change-occasion"
            (click)="$event.stopPropagation(); changeOccasion(user)"
        >
            <mat-icon>change_circle</mat-icon>
        </button>

        <button
            (click)="$event.stopPropagation(); browse(user)"
            matTooltip="Edit"
            class="action"
            mat-icon-button
            i18n-matTooltip="@@edit"
        >
            <mat-icon>edit</mat-icon>
        </button>
    </div>
    <!-- <div class="w-100" fxLayout="row" fxLayoutAlign="space-between center" *ngIf="isMobile$ | async">
        <button
            class="hover-tools-btn view"
            mat-icon-button
            matTooltip="View"
            (click)="$event.stopPropagation(); browse(user)"
            i18n-matTooltip="@@view"
        >
            <mat-icon>visibility</mat-icon>
        </button>

        <button *ngIf="!!user.user_collaboration?.edit?.status" (click)="$event.stopPropagation()" mat-icon-button>
            <mat-icon>edit</mat-icon>
        </button>
        <button (click)="$event.stopPropagation(); expansionToggled(user)" class="expand-btn" mat-icon-button>
            <mat-icon>{{ expandedFn(user) ? 'expand_less' : 'expand_more' }}</mat-icon>
        </button>
    </div> -->
</ng-template>

<ng-template #shareLoadTemp>
    <app-kd-logo-loading size="small"></app-kd-logo-loading>
</ng-template>
<ng-template #status_form>
    <form [formGroup]="statusFormGroup" fxLayout="column" fxLayoutGap="10px">
        <mat-radio-group formControlName="status" class="status-radio-group" fxLayout="column" fxLayoutGap="10px">
            <mat-radio-button
                class="approved-status"
                fxLayout="row"
                fxLayoutAlign="start center"
                fxLayoutGap="10px"
                value="approved"
                ><mat-icon>check_circle</mat-icon><span i18n>Approve</span></mat-radio-button
            >
            <mat-radio-button
                class="rejected-status"
                fxLayout="row"
                fxLayoutAlign="start center"
                fxLayoutGap="10px"
                value="rejected"
                ><mat-icon>cancel</mat-icon><span i18n>Reject</span></mat-radio-button
            >
            <mat-radio-button
                class="pending-status"
                fxLayout="row"
                fxLayoutAlign="start center"
                fxLayoutGap="10px"
                value="pending"
                ><mat-icon>pending</mat-icon><span i18n>Add to pending list</span></mat-radio-button
            >
        </mat-radio-group>
        <app-user-setting-input
            [control]="statusFormGroup.get('comment') | cast"
            type="textarea"
            class="textArea-field-user"
            [textAreaRows]="3"
            placeholder="Write a comment"
            i18n-placeholder
        >
            <label role="textarea-label"><span i18n> Comment</span> </label>
        </app-user-setting-input>
    </form>
</ng-template>
<ng-template #change_occasion>
    <mat-radio-group [formControl]="changeOccasionControl" class="course-sett-not" fxLayout="column" fxLayoutGap="10px">
        <mat-radio-button
            [disabled]="date.ispassed"
            [ngStyle]="{ opacity: date.ispassed ? 0.5 : 1 }"
            *ngFor="let date of resourceOccasionDates"
            [value]="date.id"
        >
            <div fxLayout="column">
                <span fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="3px" class="dark-blue">
                    <span class="capitalize" *ngIf="date.start_date && date.end_date">
                        {{ date.start_date | kdDateFormat : 'MMM DD, YYYY' }} -
                        {{ date.end_date | kdDateFormat : 'MMM DD, YYYY' }}
                    </span>
                    <span class="capitalize" *ngIf="date.start_date && !date.end_date">
                        {{ date.start_date | kdDateFormat : 'MMM DD, YYYY' }}
                    </span>
                    <ng-container *ngIf="Utils.isValidToEnrollOccasionBySeats(date, resource.enrollmentRequiredStatus)">
                        <ng-container *ngIf="!Utils.isUnlimitedSeatsOccasion(date)">
                            ({{ date.total_seats! - (date.approved_count ?? 0) }}
                            <span class="dark-blue" i18n>&nbsp; Seats left</span>)
                        </ng-container>
                        <ng-container *ngIf="Utils.isUnlimitedSeatsOccasion(date)">
                            (<span class="dark-blue" i18n>Open seats</span>)
                        </ng-container>
                    </ng-container>
                    <ng-container
                        *ngIf="!Utils.isValidToEnrollOccasionBySeats(date, resource.enrollmentRequiredStatus)"
                    >
                        <span class="dark-blue" i18n>No seats left</span>
                    </ng-container>
                </span>
                <div *ngIf="date.location" fxLayout="row" fxLayoutAlign="start center" class="location-wrap">
                    <mat-icon>location_on</mat-icon>
                    <span>{{ date.location }}</span>
                </div>
            </div>
        </mat-radio-button>
    </mat-radio-group>
</ng-template>
